import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const sizeClasses = {
    small: 'w-[130px]',
    medium: 'w-[160px]',
    large: 'w-[180px]',
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className={`${sizeClasses[size]} group block`}
      data-product-shop
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={comic.cover}
          alt={comic.title}
          title={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-[10px] text-accent-500"></i>
            </div>
            <span className="text-[11px] text-white font-medium">{comic.rating}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-400 line-clamp-1">{comic.author}</p>
    </Link>
  );
}